
var awardSettings = angular.module('awardSettings', ['classy', 'thresholdSettings', 'policyFlags',
    'awardPreferencesAndRules', 'awardLetter', 'interestFlags']);
awardSettings.classy.controller({
    name: 'AwardSettingsController',
    inject: ['$scope', 'authServiceFactory'],
    init: function()
    {
        //this.$.activeSection = 'account';
        //this.$.versionNo = versionNo;
    }
});

stateProviders.push({
    name: 'schoolside.settings.award',
    abstract: true,
    url: '/awardSettings',
    templateUrl: 'fast/submodules/schoolside/settings/awardSettings/awardSettings.html?v=' + versionNo,
    controller: 'AwardSettingsController'
});

